import { UserBaseAllBaseReadUserAllUserReadUserItemRead } from '../../openapi';
import { createReducer, on } from '@ngrx/store';
import {
  loadUserDetails,
  loadUserDetailsFailure,
  loadUserDetailsSuccess,
  updateUserDetails, updateUserDetailsFailure, updateUserDetailsSuccess
} from '../actions/user-details.actions';

export type UserDetails = UserBaseAllBaseReadUserAllUserReadUserItemRead;

export interface UserDetailsState {
  loading: boolean;
  pending: boolean;
  user: UserDetails | null;
}

export const userDetailsInitialState: UserDetailsState = {
  loading: false,
  pending: false,
  user: null
};

export const userDetailsReducer = createReducer(
  userDetailsInitialState,
  on(loadUserDetails, state => ({ ...state, loading: true })),
  on(loadUserDetailsSuccess, (state, action) => ({
    ...state,
    loading: false,
    user: action.user
  })),
  on(loadUserDetailsFailure, state => ({ ...state, loading: false })),
  on(updateUserDetails, state => ({ ...state, pending: true })),
  on(updateUserDetailsSuccess, (state, action) => ({ ...state, pending: false, user: action.user })),
  on(updateUserDetailsFailure, state => ({ ...state, pending: false }))
);
